<template>
  
      <div class="column" style="transform: scale(1,-1)">
        
      <div class="container" :class="{mine, user, team}" :title="titles" v-if="message">
        <!-- @click.exact="clicks()" @click.ctrl="ctclick" @click.meta="ctclick" -->

        <div class="message hover pointer click"  :class="{multilines, reply, mine, user, team}">   
                    
          <ChatMessageFile @click.prevent="clickQuote(reply.id)" v-if="reply" :name="reply.name" :text="reply.text" :team="reply.team" :image="reply.image"></ChatMessageFile>
          <!-- text -->
          <div class="row">
            <!-- body -->
             <!-- <div class="text"><slot name="body"></slot></div> -->
             <p class="text" v-html="body" @click.exact="replyClick()"></p>             
            <!-- controls -->
            <div class="row controls ch" v-if="!multilines" style="white-space: nowrap; word-break: break-all;  align-items: flex-end;">
              <!-- time -->
              <!-- <p :title="tools.ago(item.created)" style="white-space: nowrap; font-size: 12px; color: var(--g4)">{{ tools.timeonly(item.created)}}</p>               -->
              
              <!-- sent -->
               <div v-if="status == 'stored'" style="margin-left: 5px;">
                <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 4.57608L4.33386 7.90994L11 1.24301" stroke="#494949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </div>
              <!-- read -->
               <div v-if="status == 'read'" style="margin-left: 5px;">
                <svg width="20" height="11" viewBox="0 0 20 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 5.48498L10.243 9.72798L18.727 1.24298M1 5.48498L5.243 9.72798M13.728 1.24298L10.5 4.49998" stroke="#24926E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </div>

              <!-- <div v-if="message.team" class="delete"><slot name="delete"></slot></div> -->
              
            </div>
          </div>   

          <div class="row controls" v-if="multilines" style="justify-content: flex-end;white-space: nowrap;   align-items: flex-end;">
              <!-- time -->
              
              <!-- <p :title="tools.ago(item.created)" style="white-space: nowrap; word-break: break-all; font-size: 12px; color: var(--g4)">{{tools.timeonly(item.created)}}</p>               -->
              <!-- sent -->
              <div v-if="status == 'stored'" style="margin-left: 5px;">
                <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 4.57608L4.33386 7.90994L11 1.24301" stroke="#494949" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </div>
              <!-- read -->               
               <div v-if="status == 'read'" style="margin-left: 5px;">
                <svg width="20" height="11" viewBox="0 0 20 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 5.48498L10.243 9.72798L18.727 1.24298M1 5.48498L5.243 9.72798M13.728 1.24298L10.5 4.49998" stroke="#24926E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </div>

            </div>
        </div>

      </div>

      <div class="column" :class="{mine, user, team}">
          <ChatMessageFile v-for="(item, index) in files" :file="item" :key="index"/>
        </div>

        
      </div>

</template>
<script setup>
import ChatMessageFile from './ChatMessageFile.vue';
</script>
<script>
/* eslint-disable */
import Autolinker from 'autolinker';
import { defineComponent } from 'vue';
export default defineComponent({
  mounted() {  
    // 
  },
  props:{
    item: undefined, //message
    image: undefined, //message
    chatuser: undefined, //chat user
  },
  data() {
    return {    
      showmenu: false,
    }
  },
  computed: {

    message(){
      if (!this.item) return undefined
      if (!this.item.text) return undefined
      let p = this.item
      return p
    },
    
    reply(){      
      return this.item ? this.item.reply : undefined
    },
    
    files(){
      if (!this.item || !this.item.files) return []
      return this.item.files      
    },
   
    titles(){
      if (!this.item) return ''
      let p = this.item
      let humantime = this.tools.timeonly(p.created)
      let jj = JSON.stringify(p)
      return `${humantime}\n${jj}`
    },
    
    status(){
      if (!this.item || !this.item.team) return       
      if (this.item.read) return 'read'
      if (this.item.stored) return 'stored'
      return 'new'
    },
    
    // meta
    meta(){return this.item && this.item.meta ? this.item.meta : {}},

    // reply
    // reply(){return this.item.reply},
    // replyText(){return this.meta.replyText},
    // replyName(){return this.meta.replyName},
    // replyTeam(){return this.meta.replyTeam},
    // replyAvatar(){
    //   if (!this.replyTeam && this.chatuser) return this.chatuser.image
    //   if (!this.replyTeam) return ''
    //   let team = this.db.teamMember(this.replyTeam)
    //   if (!team) return undefined
    //   return team.image
    // },

    // message
    mine(){return this.item && this.item.team && this.item.uid == this.db.profile.id},
    user(){return this.item && !this.item.team},
    team(){return this.item && this.item.team && this.item.uid != this.db.profile.id},        
    multilines(){ 
      if (!this.item) return false
      if (this.item.reply) return true
      return this.item.text ? this.item.text.length > 30 : false
    },

    // autolinks
    body(){      
      let p = this.item ? this.item.text : ''
      if (!p) return ''

      p = this.escapeHtml(p)

      // mentions
      p = p.replace(/\B@[a-z0-9_-]+/gi, "<span class=\"primary bold\">$&</span>")

      // autolinks
      p = Autolinker.link(p);
      return this.tools.sanitizeHTML(p)
    },

    


  },
  
  methods: {
    ctclick(){this.$emit('ctrlclick', true)},
    deleteMessage(){this.$emit('delete', true)},
    clicks(){this.$emit('clicks', true)},
    replyClick(){this.$emit('reply', true)},
    clickQuote(id){this.$emit('quote', id)},
    escapeHtml(text){
      return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
    },
    
  },
});

</script>
<style scoped>

.container{
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 6px 0;
}

.container.mine, .container.team{
  align-items: flex-end;
  justify-content: flex-end;
}

.mine, .team{
  align-items: flex-end;
  justify-content: flex-end;
}

.container.user{
  align-items: flex-start;
  justify-content: flex-start;
}

.user{
  align-items: flex-start;
  justify-content: flex-start;
}

.message{
  position: relative;
  padding: 6px 15px;
  border-radius: 50px;  
  width: fit-content;
  max-width: 80%;
}
.message.mine{
  background-color: var(--g1);
  background-color: #292929;
}

.message.user{
  background-color: #0D4F39;
}
.message.team{
  background-color: #2A3458;
}

.message.multilines, .message.reply{
  border-radius: 15px;
}

.delete{
  font-size: 18px; 
  line-height: 24px; 
  margin-left: 4px;
}
.delete:hover{
  color: red;
}
.text{
  font-size: 15px;
  line-height: 140%;
  color: var(--g8);
  word-break: break-word; 
  /* break-all; */
}
</style>
